/**
 * Class description
 *
 * Created: 2020-07-08
 * @author Jie
 */
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";
import {TimelineLite, Timeline} from "gsap";
import {WinterHoard} from "../../WinterHoard";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {BuffaloTimelineReelsController} from "../../reel/BuffaloTimelineReelsController";

export class BuffaloNearWin implements GameRoundPresentation {

    private readonly _reelId:number;
    private readonly _duration:number;
    private readonly _abortDuration:number;
    private _stopDelay:number;
    private _quickStopDelay:number;

    private _tl:TimelineLite;
    private _data:WinterHoardParsedGameData;
    private _scatterPositions:number [] = [];
    private _inBaseGame:boolean = false;
    private _nearWinReels:boolean [];

    private _aborted:boolean = false;
    private _freespinTriggeredThisSpin:boolean = false;

    private _stagger:number;
    private _abortStagger:number;

    private _soundTl:Timeline | null;
    private _soundStarted:boolean = false;
    private _isMysterySymbols:boolean = false;
    //private _scatterPositions


    constructor(reelId:number, duration:number = 1) {
        this._reelId = reelId;
        this._duration = duration;
    }

    public getAnimation(data:SpinParsedGameData):Timeline | null {
        //this._stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;
        //this._aborted = true;

        if(!this._aborted && !(<BuffaloTimelineReelsController> WinterHoard.timelineReelsController).quickStopped && data.nearWinReels[this._reelId] && (!this._isMysterySymbols && data.nearWinBigWinReels[this._reelId] && data.nearWinReels.indexOf(true) < 0)) {
            this._tl = WinterHoard.timelineReelsController.startNearWin(this._reelId, (this._aborted)? 0 : this._duration);
            /*this._tl.add(() => {
                data.scatterPositions!.forEach((pos: number, i: number) => {
                    if(i<=this._reelId){
                        this._tl.add(Reels.getSymbol(i, pos)!.changeState({
                            state: WinterHoardGameConfig.instance.SYMBOL_STATES.plus
                        }), GameSetting.isFastSpin? 0 : 0.3);
                    }

                });

                WinterHoardGameModuleConfig.nearWinView.playOnReel(this._reelId, []);
            }, GameSetting.isFastSpin? 0 : 0.3);*/
            return this._tl;
        }
        // Special case:
        // if aborted and las bw near win is false nearWinBigWinReels: (5) [false, false, false, true, false]
        // TODO: Verify validity
        if(this._aborted && this._reelId === 3 && (!this._isMysterySymbols && data.nearWinBigWinReels[3] && !data.nearWinBigWinReels[4])) {
            this._tl = WinterHoard.timelineReelsController.startNearWin(this._reelId, (this._aborted)? 0 : this._duration);
        }
        // TODO: Verify validity
        if(this._aborted && this._reelId === 4 && (!this._isMysterySymbols && data.nearWinBigWinReels[this._reelId - 1])) {
            this._tl = WinterHoard.timelineReelsController.startNearWin(this._reelId, (this._aborted)? 0 : this._duration);
        }

        return null;
    }

    prepare(data: WinterHoardParsedGameData): void {
        this._data = data;
        this._isMysterySymbols = data.shamanspinTriggered;
    }

    public abort(isActive:boolean, data:WinterHoardParsedGameData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        /*if(isActive && this._tl) {
            this._tl.pause();
            this._tl.kill();
            //WinterHoardGameModuleConfig.nearWinView.reset();
        }*/
        this._aborted = true;
        (<BuffaloTimelineReelsController> WinterHoard.timelineReelsController).quickStopped = true;
        //WinterHoard.timelineReelsController.stopSpin(this._reelId, data, true);
        if(this._data && (<SpinParsedGameData> this._data).nearWinReels[this._reelId]) {
            const tl:TimelineLite = new TimelineLite();
            //this._tl.add(WinterHoard.timelineReelsController.stopSpin(this._reelId, data, true));
            //this._tl.timeScale(2);
            //tl.add(this._tl, "+=0.1");
            //this._tl.progress(1, false);
            return this._tl; //null; //Harlequin.timelineReelsController.startNearWin(this._reelId, duration);
        }
        /*else {
            //this._tl.progress(1, false);
            return this._tl;
            //WinterHoard.timelineReelsController.stopSpin(this._reelId, data, true);
        }*/
        return null;
    }
}